// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".magenta-text[data-v-1a891d80]{color:#f0f!important}.margin-text[data-v-1a891d80]{margin-left:-3px}", ""]);
// Exports
module.exports = exports;
